import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";

const gradientOverlay = (rightPosition: number) => css`
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 12px;
    z-index: 110;
  }

  &::before {
    left: 0;
    background-image: linear-gradient(
      to right,
      var(--fd-colors-core-navy-d-4),
      rgb(255 255 255 / 0%)
    );
  }

  &::after {
    right: ${rightPosition}px;
    background-image: linear-gradient(
      to left,
      var(--fd-colors-core-navy-d-4),
      rgb(255 255 255 / 0%)
    );
  }
`;

export const Container = styled.div`
  background-color: var(--fd-colors-core-navy-d-4);
  position: relative;
  padding-right: 96px;
  height: 100%;
  ${gradientOverlay(96)}
`;

export const ScrollContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ScrollWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
`;

export const ButtonsContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 0 var(--fd-space-space-3) 0 var(--fd-space-space-2);
  display: flex;
  align-items: center;
  gap: var(--fd-space-space-3);

  @media screen and ${breakpoints.tablet.max.sm} {
    display: none;
  }
`;

export const Embla = styled.div`
  background-color: var(--fd-colors-core-navy-d-4);
  position: relative;
  ${gradientOverlay(0)}
`;

export const EmblaViewport = styled.div`
  overflow: hidden;
`;

export const EmblaContainer = styled.div`
  display: flex;
  touch-action: pan-y pinch-zoom;
`;
